import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-page-heading',
  templateUrl: './page-heading.component.html',
  styleUrls: ['./page-heading.component.scss']
})
export class PageHeadingComponent implements OnInit {

  @Input() heading: string;
  @Input() hasBackButton = true;
  @Input() tabName: string;
  @Input() backPageName = 'pharmacy-management';

  @Input() customRoute?: string;
  @Input() customTooltip?: string;

  tooltip: string;

  constructor(private router: Router) {
  }

  ngOnInit(): void {
    if (this.customTooltip) {
      this.tooltip = this.customTooltip;
      return;
    }

    if (this.backPageName === 'claim-management') {
      this.tooltip = 'Back to Claim Management';
    }
    else if (this.backPageName === 'enterprise-management') {
      this.tooltip = 'Back to Enterprise Management';
    }
    else {
      this.tooltip = 'Back to Pharmacy Management';
    }
  }

  back(): void {
    if (this.customRoute) {
      this.router.navigate([this.customRoute]);
      return;
    }

    // QueryParams Based Routing
    if (this.tabName == null) {
      this.router.navigate(['/' + this.backPageName + '/']);
    }
    else {
      this.router.navigate(['/' + this.backPageName + '/'], {queryParams: {tab: this.tabName}});
    }
  }

}
